import { apiFetch } from './http'

function tryParseJson(text) {
  try {
    return JSON.parse(text)
  } catch {
    return null
  }
}

function parseSseFrame(frameText) {
  // Standard SSE uses lines; we accept only "data:" lines.
  // If no data lines exist, try parsing the full frame as JSON.
  const lines = frameText.split('\n')
  const dataLines = []

  for (const rawLine of lines) {
    const line = rawLine.trimEnd()
    if (!line) continue
    if (line.startsWith('data:')) {
      dataLines.push(line.slice('data:'.length).trimStart())
    }
  }

  const payloadText = dataLines.length ? dataLines.join('\n') : frameText.trim()
  if (!payloadText) return null

  return tryParseJson(payloadText) || { type: 'raw', content: payloadText }
}

export async function postSse(path, body, { signal, onEvent } = {}) {
  const res = await apiFetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
    },
    body: JSON.stringify(body ?? {}),
    signal,
  })

  const reader = res.body?.getReader()
  if (!reader) throw new Error('Streaming not supported in this environment')

  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { value, done } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })

    // SSE frames are separated by a blank line
    while (true) {
      const boundaryIndex = buffer.indexOf('\n\n')
      if (boundaryIndex === -1) break

      const frame = buffer.slice(0, boundaryIndex)
      buffer = buffer.slice(boundaryIndex + 2)

      const evt = parseSseFrame(frame)
      if (evt && onEvent) onEvent(evt)
    }
  }

  const final = buffer.trim()
  if (final) {
    const evt = parseSseFrame(final)
    if (evt && onEvent) onEvent(evt)
  }
}
